"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @param el HTMLElement
 * @returns calculated properties of DOMReact
 */
var getClientRect = function getClientRect(el) {
  var left = 0;
  var top = 0;
  var width = el.offsetWidth;
  var height = el.offsetHeight;
  // no layout thrash
  do {
    left += el.offsetLeft;
    top += el.offsetTop;
    el = el.offsetParent;
  } while (el);
  var result = {
    left: left,
    top: top,
    width: width,
    height: height,
    right: left + width,
    bottom: top + height,
    x: left,
    y: top
  };
  return __assign(__assign({}, result), {
    toJSON: function toJSON() {
      return JSON.stringify(result);
    }
  });
};
exports.default = getClientRect;